export default {
  blog: () => import("/var/www/salamis-front-2/layouts/blog.vue").then(m => m.default || m),
  contact: () => import("/var/www/salamis-front-2/layouts/contact.vue").then(m => m.default || m),
  default: () => import("/var/www/salamis-front-2/layouts/default.vue").then(m => m.default || m),
  error: () => import("/var/www/salamis-front-2/layouts/error.vue").then(m => m.default || m)
}